/**
 * Build-time switches for whole surfaces of the app.
 *
 * `doctorConsultEntry` — the doctor-facing consultation form (history-taking
 * stages, autosave, finalize). Off since the clinic moved to a paper workflow:
 * the doctor writes the visit down and staff record it afterwards, so the
 * doctor's screens are read-only. The form, its route component and its API
 * are all still in the codebase; this only removes the ways INTO it — the
 * Start-consultation buttons, draft rows opening the form, the
 * continue-editing link, and the `/consult/:id` route itself. Flip it back to
 * `true` to restore every one of them.
 */
export const features = {
  doctorConsultEntry: false,
} as const satisfies Record<string, boolean>;
